import axios from 'axios'
import store from '../store'
import i18n from '../i18n'
import { constants } from '../constants'
class AxiosController {
    constructor() {
        let service = axios.create({
            baseURL: `${constants.serverUri}/api`
        })
        service.interceptors.response.use(this.handleSuccess, this.handleError)
        service.interceptors.request.use(this.handleRequest, this.handleRequestError)
        this.service = service
    }

    handleRequest = config => {
        if (localStorage.getItem('token')) {
            config.headers = {
                Accept: 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
            }
        }
        return config
    }

    handleRequestError = error => {
        return Promise.reject(error)
    }

    handleSuccess = response => {
        if (response.data.access_token) {
            localStorage.setItem('token', response.data.access_token)
            window.Echo.connector.pusher.config.auth.headers['Authorization'] = 'Bearer ' + response.data.access_token
        }
        return response
    }

    handleError = error => {
        console.log('response', error.response)
        const { status } = error.response

        // Handle Session Timeouts
        if (status === 401) {
            localStorage.removeItem('token')
        }
        let message = error.response.data.message
        switch (message) {
            case 'invalidLoginDetails':
                message = i18n.t(`errors.${message}`)
                break
            case 'thisAccountIsBanned':
                message = i18n.t(`errors.${message}`)
                break
            default:
                break
        }
        store.dispatch('setError', { error: message }, { root: true })

        return Promise.reject(error)
    }

    redirectTo = (document, path) => {
        document.location = path
    }

    get(path, payload) {
        return this.service.get(path, payload)
    }

    patch(path, payload) {
        return this.service.patch(path, payload)
    }

    put(path, payload) {
        return this.service.put(path, payload)
    }

    delete(path, payload) {
        return this.service.delete(path, payload)
    }

    post(path, payload) {
        return this.service.post(path, payload)
    }
}

export default new AxiosController()
